import { REFERENCE_CITATION_MARKER } from '../nodes/ReferenceCitationNodeWithExportDom';

export const excludeHtmlTag = (text = ''): string => {
  return text
    .replace(/<[^>]*(ul|li|p|span|br|h[1-6])[^>]*>?/gm, '')
    .replaceAll(REFERENCE_CITATION_MARKER, '')
    .replace(/[\n\t]/g, '');
};
